import React from "react";
import { sortableHandle } from "react-sortable-hoc";
import PropTypes from "prop-types";
import { Icon } from "semantic-ui-react";
import styles from "./styles.module.css";

const DragHandle = ({ disabled }) => {
	if (disabled) {
		return <Icon name="ordered list" className={styles.dragIcon} style={{ cursor: "not-allowed", opacity: 0.5 }} />;
	}

	const SortableIcon = sortableHandle(() => {
		return <Icon name="ordered list" className={styles.dragIcon} />;
	});

	return <SortableIcon />;
};

DragHandle.propTypes = {
	disabled: PropTypes.bool,
};

export default DragHandle;
